module.exports = __webpack_public_path__ + "static/img/phone.cf4e50e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/image/phone.jpg
// module id = iwfh
// module chunks = 1